import styles from "../style.module.scss";

export const Separator = () => <div className={styles.separator} />;
